import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UserSet from '../modal/user-set';
// 部门
import depart from '@/components/department';
// 职位
import job from '@/components/jobSelect';
// 接口api
import { getAttachmentLlist, getAllSettingList, delAttchment, querySettingRule } from 'api/Attendance';
export default {
  components: {
    UserSet: UserSet,
    depart: depart,
    job: job
  },
  data: function data() {
    return {
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      sort: '',
      dir: '',
      loading: false,
      form: {},
      tableData: [{}],
      SettingList: [],
      currentSelect: {}
    };
  },
  created: function created() {
    // 获取考勤组列表
    this.handleGetAttendanceSettingList();
    // 获取表格数据
    this.handleGetAttachmentLlist();
  },
  methods: {
    // 排序
    handlerSort: function handlerSort(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.sort = prop;
      this.dir = order;
      this.handleGetAttachmentLlist();
    },
    // 部门级连选择
    selectDepart: function selectDepart(obj, current) {
      this.form.department = current.slice(-1)[0];
    },
    // 切换页码
    handleChangeCurrent: function handleChangeCurrent(val) {
      this.pagination.page = val;
      this.handleGetAttachmentLlist();
    },
    handleChangeSize: function handleChangeSize(val) {
      this.pagination.size = val;
      this.handleGetAttachmentLlist();
    },
    // 获取表单列表项
    handleGetAttachmentLlist: function handleGetAttachmentLlist() {
      var _this = this;
      var msg = _objectSpread(_objectSpread(_objectSpread({}, this.pagination), this.form), {}, {
        sort: this.sort,
        // 排序相关
        dir: this.dir
      });
      this.loading = true;
      getAttachmentLlist(msg).then(function (res) {
        if (res && res.data) {
          _this.tableData = res.data.result;
          _this.pagination.total = Number(res.data.count);
        }
      }).finally(function () {
        _this.loading = false;
      });
    },
    // 点击树
    handleNodeClick: function handleNodeClick() {},
    // 获取考勤组列表
    handleGetAttendanceSettingList: function handleGetAttendanceSettingList() {
      var _this2 = this;
      getAllSettingList().then(function (res) {
        _this2.SettingList = res.data.result;
      });
    },
    // 清除底片
    handleDelAttchment: function handleDelAttchment(params) {
      var _this3 = this;
      if (!params.img_url) {
        this.$notify({
          title: this.$t('229'),
          message: this.$t('no photo'),
          type: 'warning'
        });
        return false;
      }
      this.$confirm(this.$t('541'), this.$t('539'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66'),
        type: 'warning'
      }).then(function () {
        delAttchment(params).then(function (res) {
          _this3.$message({
            type: 'success',
            message: _this3.$t('886')
          });
          _this3.handleGetAttachmentLlist();
        });
      });
    },
    // 查看详情
    queryDetail: function queryDetail(params) {
      var _this4 = this;
      this.currentSelect = {};
      this.$refs.improve.visible = true;
      querySettingRule(params).then(function (res) {
        if (res.data) {
          _this4.currentSelect = res.data;
        }
      });
    },
    handleSHow: function handleSHow(row) {
      if (!row.img_url) {
        this.$notify({
          title: this.$t('229'),
          message: this.$t('no photo'),
          type: 'warning'
        });
        return false;
      }
      window.open(row.img_url);
    }
  }
};